<template>
  <Transition name="fade">
    <div v-if="visible" @click="visible = false" :style="{ color }" class="fixed z-50 top-0 left-0 w-full h-full bg-white">
      <div v-if="bg" class="absolute top-0 left-0 w-full h-full z-0">
        <responsive-image :src="bg" class="w-full h-full object-cover"/>
      </div>

      <div class="w-full h-full grid place-items-center">
        <div v-if="image" :class="{ spin }" class="w-72 max-w-full">
          <responsive-image :src="image" class="w-full h-auto"/>
        </div>
      </div>

      <div v-if="text" @click.stop class="absolute bottom-0 left-0 w-full text-center">
        <div v-html="text" class="lg:text-xl"></div>
      </div>
    </div>
  </Transition>
</template>

<script>
  import store from '@/store'

  export default {
    name: 'intro-screen',
    props: {
      page: Object
    },
    computed: {
      visible: {
        get () {
          return store.state.introVisible
        },
        set (val) {
          store.commit('setIntroVisible', val)
        }
      },
      image () {
        if (!this.page || !this.page.acf) return
        return this.page.acf.logo
      },
      spin () {
        if (!this.page || !this.page.acf) return
        return this.page.acf.spin
      },
      duration () {
        if (!this.page || !this.page.acf) return
        return this.page.acf.duration
      },
      text () {
        if (!this.page || !this.page.acf) return
        return this.page.acf.intro_text
      },
      color () {
        if (!this.page || !this.page.acf) return
        return this.page.acf.color || 'black'
      },
      bg () {
        if (!this.page || !this.page.acf) return
        return this.page.acf.bg_image
      }
    },
    mounted () {
      if (!this.page || !this.page.acf) {
        this.visible = false
        return
      }

      setTimeout(() => {
        this.visible = false
      }, this.duration || 3000)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/IntroScreen.vue